import React from 'react';
import PropTypes from 'prop-types';

// Components
import {AttributeText} from '../../../components/components/atoms/AttributeText';
import ChargeRow from './components/ChargeRow';
import ChargeTitle from './components/ChargeTitle';
import Fields from '../GasSectionCard/components/Fields';

// Attributes
import dynamicFieldAttribute from '../../attributes/dynamicField.attribute.gas';

// Lib
import humanizeGasChargeLabel from '../../lib/humanizeGasChargeLabel.lib.gas';

// A GasCharge only becomes a real charge against the driver once `charge` is
// set (see ops4_backend's apply_gas_charges) - that's the only "was this
// actually charged" signal, so that's all this shows per charge.
const GasChargesList = ({gas}) => {
  const charges = gas?.gas_charges || [];
  if (!charges.length) return null;

  return (
    <Fields>
      {charges.map((charge) => (
        <ChargeRow key={charge.id}>
          <ChargeTitle>{humanizeGasChargeLabel(charge)}</ChargeTitle>
          <Fields>
            <AttributeText
              attribute={dynamicFieldAttribute(
                {field: 'amount', label: 'Amount', type: 'number'},
                charge.amount
              )}
              preValue="$"
            >
              Amount
            </AttributeText>
            <AttributeText
              attribute={dynamicFieldAttribute(
                {field: 'charged', label: 'Charged', type: 'boolean'},
                !!charge.charge
              )}
            >
              Charged
            </AttributeText>
          </Fields>
        </ChargeRow>
      ))}
    </Fields>
  );
};

GasChargesList.propTypes = {
  gas: PropTypes.object,
};

export default GasChargesList;
